import { api } from "./api";
import type { EggSale } from "@/types/models";

interface PaginatedResponse<T> {
  data: T[];
  meta: {
    total: number;
    limit: number;
    offset: number;
  };
}

import type { SalePaymentLine } from "@/hooks/useSalePayments";
export type { SalePaymentLine };

export const eggSaleService = {
  create: (data: {
    date: string;
    qty_eggs: number;
    price_per_egg: number;
    total_amount: number;
    broken_eggs?: number;
    buyer_id?: number;
    /** Owner-only approval for a sale that breaches the buyer's credit terms. */
    credit_override?: boolean;
    notes?: string;
    payments?: SalePaymentLine[];
  }) =>
    api
      .post<{ success: boolean; data: EggSale }>("/egg-sales", data)
      .then((r) => r.data),
  list: (params?: Record<string, string | number>) =>
    api
      .get<PaginatedResponse<EggSale>>("/egg-sales", { params })
      .then((r) => r.data),
  get: (id: number) =>
    api
      .get<{ success: boolean; data: EggSale }>(`/egg-sales/${id}`)
      .then((r) => r.data),
  update: (id: number, data: {
    date: string;
    qty_eggs: number;
    price_per_egg: number;
    total_amount: number;
    broken_eggs?: number;
    buyer_id?: number;
    /** Owner-only approval for a sale that breaches the buyer's credit terms. */
    credit_override?: boolean;
    notes?: string;
  }) =>
    api
      .put<{ success: boolean; data: EggSale }>(`/egg-sales/${id}`, data)
      .then((r) => r.data),
  // confirmPaid: the owner has seen "money has been paid on this sale" and
  // said delete.
  delete: (id: number, confirmPaid = false) =>
    api.delete(`/egg-sales/${id}`, { params: confirmPaid ? { confirm_paid: "true" } : undefined }).then((r) => r.data),
};
